export const getallcourse=`query GetAllCourses {
  allCourses {
    id
    title
    status
    enrolmentStartDate
    enrolmentEndDate
  }
}`